<template>
  <div>
    <px-view-header title="Cotações" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <div class="mt-5">
      <listagem-cotacao-header :on-click-refresh="onClickRefresh"
                               :on-change-filter="onChangeFilter"
                               @change="onChangeFilter"/>
      <lista-cotacao :cotacoes="cotacoes" :loading="loading"
                     :on-change-options="onChangeOptions"
                     :options-list="optionsList"
                     @update="onClickRefresh"
                     @remove="onRemove"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import paginationMixin from '@/mixins/pagination-mixin';
import CotacoesListagemService from '@/modules/cotacao/listagem/service/cotacoes-listagem-service';
import CotacaoService from '../cotacao-service';
import ListaCotacao from './ListaCotacao.vue';
import ListagemCotacaoHeader from './ListagemCotacaoHeader.vue';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      cotacoes: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 10,
        offset: 0,
        filter: '',
        sort: 'createdIn',
        sortDesc: true,
      },
      loading: false,
      breadcrumbs: [
        { text: 'Gestão de compras' },
        { text: 'Cotações' },
      ],
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('listagemCotacao', ['stringFilter']),
  },
  methods: {
    onChangeFilter() {
      this.listOptions.filter = this.stringFilter;
      this.resetPage();
      this.getCotacoes();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getCotacoes();
    },
    onClickRefresh() {
      this.getCotacoes();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    onRemove(item) {
      this.loading = true;
      CotacaoService.excluirRascunho(item.id)
        .then(() => {
          this.$toast('Rascunho excluido com sucesso', { color: 'success' });
          this.getCotacoes();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCotacoes() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      return CotacoesListagemService.getCotacoes({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.cotacoes = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  components: {
    ListaCotacao,
    ListagemCotacaoHeader,
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
    this.listOptions.filter = this.stringFilter;
  },
};
</script>
